import type { TOC } from '@ember/component/template-only'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { CourseProgressAverages } from 'teacher-ui-client/components/giraffe/charts/course-progress/averages'
import { CourseProgressHistory } from 'teacher-ui-client/components/giraffe/charts/course-progress/history'
import { CourseProgressTotals } from 'teacher-ui-client/components/giraffe/charts/course-progress/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import type { CourseProgressMathsLessonsRoute } from 'teacher-ui-client/reporting/ui-scope/maths/course-progress/lessons/route'
import RouteTemplate from 'ember-route-template'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<CourseProgressMathsLessonsRoute>
}

export const MathsCourseProgressLessons: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.courseProgressLessons.maths"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.lessonsProgressTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.maths.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.lessonsProgressTotals}}>
    {{#each @model.lessonsProgressTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressTotals
          @data={{gradeData}}
          @product={{@model.product}}
          @precinct={{@model.precinct}}
          @grade={{fullGradeName gradeData.grade_position}}
          @title={{t "reporting.chartTitles.courseProgressTotals"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.courseProgressTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressTotals"}}
        />
      </div>
    {{/each}}
    {{#each @model.lessonsProgressAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressAverages
          @data={{gradeData}}
          @precinct={{Precinct.MS_LESSONS}}
          @title={{t (concat "reporting.chartTitles.courseProgressAverages." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressAverages"}}
        />
      </div>
    {{/each}}
    {{#if @model.lessonsProgressHistory}}
      <CourseProgressHistory
        @tooltip={{t "reporting.tooltips.courseProgressHistory.chartInfo"}}
        @students={{@model.scopedStudents}}
        @courseProgressHistory={{@model.lessonsProgressHistory}}
        @product={{@model.product}}
        @precinct={{@model.precinct}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.maths.student-summary"
        @themeKey={{ThemeKeys.green}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(MathsCourseProgressLessons)
